import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import { DatePicker, Button, Table, Select, Tooltip, Col, Row, Input, Space, Divider } from "antd";
import { HexColorPicker } from "react-colorful";
import { Column } from '@ant-design/plots';

import { GET_DASHBOARD_3_GENERAL_VS_TOOL_INSTALL } from "../graphql/modules";
import { warnNotify } from "../util";

export const DashboardV2D3 = () => {
    const [year, setYear] = useState('');
    const [sites, setSites] = useState([]);
    const [generalPermitBarColor, setGeneralPermitBarColor] = useState('#22CBCC');
    const [toolPermitBarColor, setToolPermitBarColor] = useState('#2989FF');

    const [GetDashboard3Data, { data: dashboard3Data, loading: dashboard3Loading, error: dashboard3Error }] = useLazyQuery(GET_DASHBOARD_3_GENERAL_VS_TOOL_INSTALL, {
        variables: {
          year: year,
          sites: sites,
        },
        fetchPolicy: "cache-and-network",
    });

    const rawData = [
      {
        "key": 1,
        "month": "January",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 2,
        "month": "February",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 3,
        "month": "March",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 4,
        "month": "April",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 5,
        "month": "May",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 6,
        "month": "June",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 7,
        "month": "July",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 8,
        "month": "August",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 9,
        "month": "September",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 10,
        "month": "October",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 11,
        "month": "November",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      },
      {
        "key": 12,
        "month": "December",
        "generalPermitCount": 0,
        "toolPermitCount": 0
      }
    ];

    const data = rawData.flatMap(item => [
      { month: item.month, type: 'General Permit', count: item.generalPermitCount },
      { month: item.month, type: 'Tool Permit', count: item.toolPermitCount }
    ]);

    const transformData = (data) => {
      return data.flatMap(item => [
        { month: item.month, type: 'General Permit', count: item.generalPermitCount },
        { month: item.month, type: 'Tool Install Permit', count: item.toolPermitCount }
      ]);
    }

    useEffect(() => {
        if (dashboard3Error) {
          warnNotify(dashboard3Error.message);
        }
    }, [dashboard3Error]);

    const config = {
      isGroup: true,
      xField: 'month',
      yField: 'count',
      seriesField: 'type',
      color: ({ type }) => {
        if (type === 'General Permit') {
          return generalPermitBarColor ? generalPermitBarColor : '#22CBCC';
        }
        if (type === 'Tool Install Permit') {
          return toolPermitBarColor ? toolPermitBarColor : '#2989FF';
        }
        return '#000000'; // Default color if type doesn't match
      },
      style: {
        inset: 5
      },
      label: {
        text: (originData) => {
            const val = parseFloat(originData.value);
            if (val < 0.05) {
                return (val * 100).toFixed(1) + '%';
            }
            return '';
        },
        offset: 10,
      },
      legend: {
        position: 'top',
        itemName: {
            style: {
                fill: '#666',
                fontSize: 18,
            },
        },
      },
    };

    const handleYearChange = (date, dateString) => {
      if (date) {
        const selectedYear = date.format('YYYY');
        console.log(selectedYear);
        setYear(selectedYear);
      } else {
        console.log('No year selected');
      }
    };
  
    const handleSiteChange = (value) => {
      setSites(value);
    };
  
    const handleSubmit = () => {
      console.log('Year: ', year);
      console.log('Selected Sites: ', sites);
      if (year !== '' && sites.length > 0) {
        GetDashboard3Data();
      } else {
        warnNotify('You need to select a year and at least one site');
      }
    };

    return (
        <Fragment>

            <div className="row dec-row">
                <div className="card">
                <div className="col-12 col-md-12">
                    <div className="col-12 col-md-12 text-left">
                        <h4 className="text-left">General vs Tool Install Permit</h4>
                    </div>

                    <div className="row dec-row">
                        <div className="col-12 col-md-12">
                            <div className="col-3 col-md-3">
                                    <Space
                                        className="col-12 col-md-12"
                                        direction="vertical"
                                        size="middle"
                                    >

                                        <div className="col-12 col-md-12">
                                            <DatePicker 
                                                placeholder="Select Year" 
                                                style={{ width: "100%" }} 
                                                picker="year"
                                                onChange={handleYearChange}
                                            />
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <Select
                                                    mode="multiple"
                                                    allowClear
                                                    placeholder="Please select site(s)"
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    maxTagCount="responsive"
                                                    maxTagPlaceholder={(omittedValues) => (
                                                        <Tooltip
                                                        styles={{
                                                            root: {
                                                            pointerEvents: 'none',
                                                            },
                                                        }}
                                                        title={omittedValues.map(({ label }) => label).join(', ')}
                                                        >
                                                        <span>...</span>
                                                        </Tooltip>
                                                    )}
                                                    onChange={handleSiteChange}
                                                    options={
                                                        [
                                                            {
                                                                value: "604a288405a8ed2d4d4bba4b",
                                                                label: "Fab 10A1",
                                                            },
                                                            {
                                                                value: "604a286b05a8ed2d4d4bba4a",
                                                                label: "Fab 10A2",
                                                            },
                                                            {
                                                                value: "604a28bb05a8ed2d4d4bba4c",
                                                                label: "Fab 10N",
                                                            },
                                                            {
                                                                value: "60cafd5a4e8783df2ab8afff",
                                                                label: "Fab 10NX",
                                                            },
                                                            {
                                                                value: "6052a5b7be761a25aaec1bd1",
                                                                label: "Fab 10W",
                                                            },
                                                            {
                                                                value: "604a28ee05a8ed2d4d4bba4e",
                                                                label: "Fab 10X",
                                                            }
                                                        ]
                                                    }
                                                />
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <Button
                                                style={{
                                                    width: '100%',
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </div>

                                        <Divider />

                                        <div className="row dec-row"> 
                                          <div className="col-6 col-md-6">
                                            <HexColorPicker color={generalPermitBarColor} onChange={setGeneralPermitBarColor} 
                                                style={{
                                                  width: '120px',
                                                  height: '120px',
                                                }} 
                                            />
                                            <br />
                                            General Permit Bar
                                          </div>

                                          <div className="col-6 col-md-6">
                                            
                                            <HexColorPicker color={toolPermitBarColor} onChange={setToolPermitBarColor} 
                                              style={{
                                                width: '120px',
                                                height: '120px',
                                              }} 
                                            />
                                            <br />
                                            Tool Install Bar
                                          </div>
                                        </div>

                                    </Space>
                            </div>

                            <div className="col-9 col-md-9">
                                    <div className="card">
                                        <Column {...config} loading={dashboard3Loading} data={dashboard3Data ? transformData(dashboard3Data.GeneralAndToolInstallPermitCount.results) : transformData(rawData)} />
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </Fragment>
    )
}